var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center",attrs:{"id":"page-title-component"}},[_c('small',{staticClass:"text-muted mb-1 text-uppercase"},[_c('fa-icon',{staticClass:"mr-1",attrs:{"icon":_vm.categoryIcon,"fixed-width":""}}),_vm._v(_vm._s(_vm.category))],1),_c('h1',{staticClass:"h2 m-0"},[_vm._v(_vm._s(_vm.pageTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }